import { Stack } from "@mui/material"
import { categories } from "../utils/constants"

/* -------------------------------------------------------------------------------------------------------------------------------------------(When onclick the selected category.name is set to the styles applied)------------------------------------------------------------------------------------------------------------------------------------------------------------*/
const SideBar = ({ selectedCategory, setSelectedCategory}) =>  (
<Stack
    direction="row"
    sx={{overflowY: "auto", height: { sx: 'auto', md: '95%'}, flexDirection: { md: 'column' }
    }}
    >
        {categories.map((category) => (
            <button className="category-btn" onClick={() => setSelectedCategory (category.name)} style={{background: category.name === selectedCategory && 'green', color: 'white'}} key={category.name}> 
                <span style={{ color: category.name === selectedCategory ? 'white' : 'green', marginRight: '15px'}}>{category.icon}</span> {/* ICON */}
                <span style={{ opacity: category.name === selectedCategory ? '1' : '0.85'}}>{category.name}</span> {/* CATEGORY NAME */}
            </button>
        ))}

</Stack>

)


export default SideBar